import React from "react";
import { FormField, Box, Text, IcoMoon, CloseIcon } from "@usap/uicomponents";
import { BoxWithPointer, TextInputWithEllipsis } from "./StyledCSS";
import useWmoEnabled from '@usap/carparts/src/shared/hooks/useWmoEnabled'

export default function InputText({
  label,
  id,
  name,
  type,
  value,
  error,
  placeholder,
  onChange,
  onBlur,
  disabled = false,
  ariaLabel
}) {
  const isWmoEnabled = useWmoEnabled();
  const resetClick = () => {
    onChange({
      target: {
        name: name,
        value: ""
      }
    });
  };

  const onBlurFun = event => {
    if (onBlur) {
      onBlur(event.target.name);
    }
  };

  const onKeyPressFun = event => {
    if (type === "number") {
      const charCode = event.charCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57))
        event.preventDefault();
    }
  };

  return (
    <React.Fragment>
      <FormField label={label} htmlFor={id}>
        <Box
          background="white"
          round="xsmall"
          border={{ color: error ? "status-critical" : "dark-4" }}
          style={{ position: "relative" }}
        >
          <TextInputWithEllipsis
            plain
            id={id}
            type={type}
            name={name}
            aria-label={ariaLabel}
            size={isWmoEnabled ?"large" :"small"}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
            onBlur={onBlurFun}
            disabled={disabled}
            onKeyPress={onKeyPressFun}
          />
          {value && (
            <BoxWithPointer
              height="24px"
              style={{
                boxShadow: "none",
                position: "absolute",
                top: isWmoEnabled ? 10 : 8,
                right: 8,
                height: 24
              }}
              onClick={resetClick}
            >
              <IcoMoon
                icon={CloseIcon}
                size="24px"
                color={error ? "status-critical" : (isWmoEnabled ? "dark-5": "dark-4")}
              />
            </BoxWithPointer>
          )}
        </Box>
      </FormField>
      <Text
        style={{ display: "block", marginTop: "-10px" }}
        color="status-critical"
        size="xsmall"
      >
        {error}
      </Text>
    </React.Fragment>
  );
}
